import React from 'react';
import { Home, Info, Heart, Briefcase, Award, Users, ArrowRight, Globe, Linkedin, Leaf } from 'lucide-react';
import { NavItem, Project, Partner, Article } from './types';

export const NAV_ITEMS: NavItem[] = [
  { id: 'hero', label: 'Home', icon: <Home size={20} /> },
  { id: 'story', label: 'Story', icon: <Info size={20} /> },
  { id: 'impact', label: 'Impact', icon: <Heart size={20} /> },
  { id: 'projects', label: 'Work', icon: <Briefcase size={20} /> },
  { id: 'partners', label: 'Partners', icon: <Users size={20} /> },
];

export const PROJECTS: Project[] = [
  { title: "The Nook", location: "St. Petersburg, FL", image: "https://picsum.photos/800/600?random=1" },
  { title: "Eco-Haven 1", location: "Tampa, FL", image: "https://picsum.photos/800/600?random=2" },
  { title: "Green Horizon", location: "Clearwater, FL", image: "https://picsum.photos/800/600?random=3" },
  { title: "Solar Point", location: "Sarasota, FL", image: "https://picsum.photos/800/600?random=4" },
];

export const PARTNERS: Partner[] = [
  { name: "Deslandes Design Build" },
  { name: "Certified B Corporation" },
  { name: "1% for the Planet" },
  { name: "We Are Neutral" },
  { name: "Florida for Good" },
  { name: "For Good Movement" },
  { name: "Legacy Vacation Resorts" },
];

export const ARTICLES: Article[] = [
  { title: "Redefining Real Estate", source: "Tampa Bay Times", link: "#" },
  { title: "Building for the Future", source: "Green Building News", link: "#" },
  { title: "The B-Corp Difference", source: "Forbes Real Estate Council", link: "#" },
];

export const BRAND = {
  colors: {
    teal: '#76C2C1',
    charcoal: '#4A4A4A',
    slate: '#333333',
    gray: '#666666',
  }
};